import { isDefined, isEmpty } from '@hsp/utilities';

import { paths } from 'constants/paths';
import { PathKeys } from 'types/constants/path.type';

export const convertPathKey = (key: PathKeys) => {
  // reason: trouble determining what the type of previousValue should be, in this case
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return key.split('.').reduce((previousValue: any, currentValue) => {
    if (!isDefined(previousValue)) {
      throw new Error('Unknown path provided');
    }

    const current = previousValue[currentValue];

    if (!isDefined(current) || isEmpty(current)) {
      throw new Error('Unknown path provided');
    }

    return current;
  }, paths);
};
